import { render, staticRenderFns } from "./DefaultPopup.vue?vue&type=template&id=f8cdad24&scoped=true&"
import script from "./DefaultPopup.vue?vue&type=script&lang=ts&"
export * from "./DefaultPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultPopup.vue?vue&type=style&index=0&id=f8cdad24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cdad24",
  null
  
)

export default component.exports